// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ifxa","colBig":"styles_colBig__2uVha","colSmall":"styles_colSmall__1IhG0","shopifyNameWrapper":"styles_shopifyNameWrapper__O5md2"};